import styled from '@emotion/styled'

export const Item = styled.div`
  display: grid;
  grid-template-columns: 120px auto 120px;
`

export const Total = styled.div`
  display: grid;
  grid-template-columns: auto 120px;
`

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
`
